export default {
  filters: {
    addFilter: "Add filter",
    filter: "filter(s)",
    filterCategories: "Filter Catergories",
  },
  resetSettings: "Are you sure to reset the settings?",
  settingsWillBeGone: "All your settings will be gone!",
};
